module.exports = __webpack_public_path__ + "static/media/share_3.e3a2a1fe.png";